import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Upload5 } from 'blaze-ui/icons'
import Styles from './Uploads.module.scss'
import { DropzoneProps } from './Types'
import { useImagePickerContext } from '../ImagePickerContext'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ACCEPTED_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import cx from 'classnames'

const DragOverlay = () => (
  <div className={Styles.dragOverlay}>
    <div className={Styles.dragOverlayButton}>
      <Upload5 color="var(--light-100)" size={35} />
    </div>
    <Heading level={4} color="var(--selected-stroke)">
      Drop anywhere to upload
    </Heading>
  </div>
)

export const Dropzone = ({
  isDragActive,
  onPress,
  accept,
  className,
  buttonVariant = 'primary',
  buttonLabel = 'Upload Images',
  labelVariant = 'largeList',
  label = 'Drag & Drop',
}: DropzoneProps) => {
  const { isUploading } = useImagePickerContext()
  const uploadButtonLabel = accept?.includes(ACCEPTED_VIDEO_MIME_TYPES) ? 'Upload Images & Videos' : buttonLabel

  return (
    <div className={cx(Styles.dropzone, className)}>
      <img
        src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/designer/nru3u9ukq2ovm9gslvj6"
        alt=""
      />
      <Text variant={labelVariant}>{label}</Text>
      <div className={Styles.button}>
        <Button
          fullWidth
          size="md"
          variant={buttonVariant}
          frontIcon={Upload5}
          onPress={onPress}
          aria-label="Upload Files"
          isDisabled={isUploading}
        >
          {isUploading ? 'Uploading...' : uploadButtonLabel}
        </Button>
      </div>
      {isDragActive && <DragOverlay />}
    </div>
  )
}
